<template>
  <div>
    <div class="TitlePage page landscape">
      <!-- <div class="background"></div> -->
      <div class="container">
        <div class="info">
          <h2>Oferta dla</h2>
          <h1 :data-clientName="clientName">{{ clientName }}</h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TitlePage',

  props: {
    clientName: {
      type: String,
      default: 'Neadoo.london',
      required: true,
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Open+Sans&family=Raleway:wght@300;400;600;700;800;900&display=swap');

h1,
h2,
h3 {
  font-family: 'Raleway', sans-serif;
  font-weight: 800;
  margin: 0;
  padding: 0;
  text-align: left;
}

h1 {
  font-size: 72px;
  margin-top: 50px;
  line-height: 0px;
  text-align: left;
}

h2 {
  font-size: 72px;
}

.TitlePage .info {
  margin-top: 380px;
  margin-left: -400px;
}

.TitlePage {
  background: url('/seo.jpg');
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  z-index: 0;
  text-transform: uppercase;
}
</style>
